import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedDistrict } from "../../store/pointsSlice";
import { formatCo2, getCo2Totals } from "../../utils/co2";
import "./DistrictsList.css";

const DistrictsList = ({ highlightDistrict }) => {
    const dispatch = useDispatch();
    const points = useSelector((state) => state.points.points || []);
    const selectedDistrict = useSelector(
        (state) => state.points.selectedDistrict
    );
    const selectedYear = useSelector(
        (state) => state.points.selectedYear || "2030"
    );
    const loading = useSelector((state) => state.points.loading);
    const co2Totals = useMemo(
        () => getCo2Totals(points, selectedYear),
        [points, selectedYear]
    );

    const federalDistricts = [
        { id: "Центральный", name: "Центральный" },
        { id: "Северо-Западный", name: "Северо-Западный" },
        { id: "Южный", name: "Южный" },
        { id: "Северо-Кавказский", name: "Северо-Кавказский" },
        { id: "Приволжский", name: "Приволжский" },
        { id: "Уральский", name: "Уральский" },
        { id: "Сибирский", name: "Сибирский" },
        { id: "Дальневосточный", name: "Дальневосточный" },
    ];

    const getCO2Value = (districtId) => {
        if (loading) return "Загрузка...";

        const value = co2Totals.districts[districtId];
        if (!value) return "по запросу";

        return formatCo2(value);
    };

    const handleDistrictClick = (districtId) => {
        dispatch(setSelectedDistrict(districtId));
        highlightDistrict(districtId);
    };

    return (
        <div className="districts-list">
            {federalDistricts.map((district) => (
                <div
                    key={district.id}
                    className={`district ${
                        selectedDistrict === district.id ? "active" : ""
                    }`}
                    onClick={() => handleDistrictClick(district.id)}
                >
                    <h4>{district.name}</h4>
                    <p>Потенциал поглощения CO₂: {getCO2Value(district.id)}</p>
                </div>
            ))}
        </div>
    );
};

export default DistrictsList;
